export const 유튜브_링크 = 'https://www.youtube.com/@mr.devello';

export const 블로그_링크 = 'https://blog.naver.com/mrdevello';

export const 인스타그램_링크 = 'https://www.instagram.com/mr.devello/';

export const 네이버_지도_링크 = 'https://naver.me/5wHvTBLL';

export const 포트폴리오_PDF_링크 = '/files/mrdevello-portfolio.pdf';

export const 회사소개_PDF_링크 = '/files/mrdevello-introduction.pdf';
